import { useEffect, useState } from "react";
import { ArrowRight, Check, Copy, Heart, Share2, Sparkles } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import "./MasterLandingSuccess.css";

interface SuccessLocationState {
  name?: string;
}

export const MasterLandingSuccessPage = () => {
  const location = useLocation();

  const [shareMessage, setShareMessage] = useState("");

  const state = location.state as SuccessLocationState | null;

  const name = state?.name?.trim() ?? "";

  const canNativeShare = typeof window !== "undefined" && typeof window.navigator.share === "function";

  useEffect(() => {
    const previousTitle = document.title;

    document.title = "Заявка отправлена — Looksty";

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    return () => {
      document.title = previousTitle;
    };
  }, []);

  const handleShare = async () => {
    const shareData = {
      title: "Looksty",
      text: "Посмотри Looksty — новую визуальную платформу для мастеров красоты в Томске.",
      url: `${window.location.origin}/master-lending`,
    };

    try {
      if (canNativeShare) {
        await window.navigator.share(shareData);
        return;
      }

      if (typeof window.navigator.clipboard?.writeText === "function") {
        await window.navigator.clipboard.writeText(shareData.url);

        setShareMessage("Ссылка скопирована");
      } else {
        setShareMessage("Скопируйте ссылку из адресной строки");
      }
    } catch (error) {
      // Закрытие системного окна «Поделиться» —
      // это не ошибка, которую нужно показывать.
      if (error instanceof DOMException && error.name === "AbortError") {
        return;
      }

      setShareMessage("Не удалось поделиться ссылкой");
    }

    window.setTimeout(() => {
      setShareMessage("");
    }, 2200);
  };

  return (
    <main className="master-landing-success-page">
      <header className="ll-header">
        <Link to="/master-lending" className="ll-logo" aria-label="Looksty">
          Looksty
        </Link>

        <span className="ll-status-pill">
          <Check size={14} />
          Заявка принята
        </span>
      </header>

      <section className="ll-success-content">
        <span className="ll-success-icon">
          <Check size={30} strokeWidth={3} />
        </span>

        <span className="ll-eyebrow ll-success-kicker">
          <Sparkles size={13} />
          Вы среди первых
        </span>

        <h1>
          {name ? `${name}, ` : ""}
          ваше место в новой beauty-ленте уже ждёт.
        </h1>

        <p className="ll-success-lead">Спасибо за доверие. Заявка уже у нас — мы лично свяжемся с вами, поможем оформить профиль.</p>

        <p className="ll-success-manifest">Ваша работа — как причина выбрать именно вас.</p>

        <div className="ll-success-share">
          <div className="ll-success-share-copy">
            <span className="ll-icon-badge">
              <Heart size={18} color="#fff" />
            </span>

            <div>
              <strong>И не забудьте рассказать подругам</strong>
              <p>Возможно, именно вы приведёте в Looksty следующего талантливого мастера.</p>
            </div>
          </div>

          <button className="ll-btn" type="button" onClick={handleShare}>
            {canNativeShare ? <Share2 size={17} /> : <Copy size={17} />}
            {canNativeShare ? "Рассказать о Looksty" : "Скопировать ссылку"}
          </button>
        </div>

        <Link to="/" className="ll-link ll-success-home">
          Перейти в Looksty
          <ArrowRight size={16} />
        </Link>

        <p className="ll-success-note">Скоро напишем вам лично. Без ботов, рассылок и бездушных писем.</p>
      </section>

      {shareMessage && (
        <div className="ll-toast" role="status">
          {shareMessage}
        </div>
      )}
    </main>
  );
};
